import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtilsPropertiesService {
  constructor(private http: HttpClient, private translate: TranslateService) { }

  async shareProperty(property: any, agentId: any = null) {
    const title = property.title;
    const uniqueId = property.uniqueId;
    const agent = agentId && agentId !== null ? `?share=${agentId}` : '';
    const pKey = this.translate.instant('routes.property');
    const newURL = `${document.head.baseURI}${pKey ? pKey : 'property'}/${this.getTitleFormat(title)}/${uniqueId}${agent}`;

    window.navigator.share({
      title: `${title}`,
      text: `${title}`,
      url: newURL,
    });
  }

  async shareEnterprise(property: any, agentId: any = null) {
    const title = property.title;
    const uniqueId = property.uniqueId;
    const agent = agentId && agentId !== null ? `?share=${agentId}` : '';
    const pKey = this.translate.instant('routes.enterprises');
    const newURL = `${document.head.baseURI}${pKey ? pKey : 'developments'}/${this.getTitleFormat(title)}/${uniqueId}${agent}`;

    window.navigator.share({
      title: `${title}`,
      text: `${title}`,
      url: newURL,
    });
  }

  getUrl(title: string, uniqueId: any, lang: string) {
    let propertyLink = 'property';
    if (lang == 'pt') {
      propertyLink = 'imovel';
    } else if (lang == 'es') {
      propertyLink = 'propiedad';
    } else if (lang == 'fr') {
      propertyLink = 'immobilie';
    } else if (lang == 'de') {
      propertyLink = 'propriete';
    }
    return `${document.head.baseURI}${propertyLink}/${this.getTitleFormat(title)}/${uniqueId}`;
  }


  getTitleFormat(title: string) {
    return title
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove acentos
      .replace(/([^\w]+|\s+)/g, '-') // Substitui espaço e outros caracteres por hífen
      .replace(/\-\-+/g, '-') // Substitui multiplos hífens por um único hífen
      .replace(/(^-+|-+$)/, '')
      .toLowerCase();
  }

  generateRouterLink(title: string, uniqueId: string) {
    return ['/property', this.getTitleFormat(title), uniqueId];
  }

  generateAgentRouterLink(name: any, id: any) {
    return ['/agents', this.getTitleFormat(name), id];
  }

  generateEnterpriseLink(title: string, uniqueId: string) {
    return ['/developments', this.getTitleFormat(title), uniqueId];
  }

  generateMlsLink(title: string, uniqueId: string, link: string) {
    const link1 = link.startsWith('http') ? link : 'https://' + link;
    return `${link1}/property/${this.getTitleFormat(title)}/${uniqueId}`;
  }

  generateMlsEnterpriseLink(title: string, uniqueId: string, link: string) {
    const link1 = link.startsWith('http') ? link : 'https://' + link;
    return `${link1}/developments/${this.getTitleFormat(title)}/${uniqueId}`;
  }

  getUrlExtension(url: any) {
    return url.split(/[#?]/)[1].split('.').pop().trim();
  }

  async onImageEdit(imgUrl: any) {
    var imgExt = this.getUrlExtension(imgUrl);

    const response = await fetch(imgUrl);
    const blob = await response.blob();
    const file = new File([blob], 'profileImage.' + imgExt, {
      type: blob.type,
    });
    return file;
  }

  getImage(url: string): Observable<any> {
    return this.http.get(url, { responseType: 'blob' });
  }

  private readFile(blob: Blob): Observable<string> {
    return new Observable((obs: any) => {
      const reader = new FileReader();

      reader.onerror = (err) => obs.error(err);
      reader.onabort = (err) => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();
      return reader.readAsDataURL(blob);
    });
  }

  async sharePropertyReview(property: any, token: any = null) {
    const title = property.title;
    const uniqueId = property.uniqueId;
    const pKey = this.translate.instant('routes.property');
    const newURL = `${document.head.baseURI}${pKey ? pKey : 'property'}/${this.getTitleFormat(title)}/${uniqueId}?review=${token}`;

    window.navigator.share({
      title: `${title}`,
      text: `${title}`,
      url: newURL,
    });
  }
}
